var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFillBalloonChatWonLg = function SvgFillBalloonChatWonLg(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    fill: "none",
    viewBox: "0 0 60 60"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFD70F",
    d: "M30.003 49.099c12.379 0 22.414-8.491 22.414-18.965S42.382 11.168 30.003 11.168 7.59 19.659 7.59 30.134c0 10.474 10.035 18.965 22.414 18.965"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFD70F",
    d: "M11.518 33.343a.75.75 0 0 1 1.255-.336L22.9 43.136a.75.75 0 0 1-.336 1.255L8.73 48.098a.75.75 0 0 1-.918-.919z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#F8A300",
    d: "m39.663 25.803.775-2.677a.3.3 0 0 0-.288-.384h-3.202a.3.3 0 0 0-.292.233l-2.363 10.22-2.614-10.227a.3.3 0 0 0-.29-.226h-2.784a.3.3 0 0 0-.29.226l-2.627 10.228-2.35-10.221a.3.3 0 0 0-.292-.233h-3.202a.3.3 0 0 0-.288.384l.775 2.677h-3.419a.3.3 0 0 0-.3.3v2.824a.3.3 0 0 0 .3.3h4.399l2.488 8.67a.3.3 0 0 0 .289.217h2.891a.3.3 0 0 0 .288-.216l2.73-9.396 2.73 9.396a.3.3 0 0 0 .288.216h2.905a.3.3 0 0 0 .288-.217l2.475-8.67h4.4a.3.3 0 0 0 .3-.3v-2.824a.3.3 0 0 0-.3-.3z"
  })));
};
export default SvgFillBalloonChatWonLg;